(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-number-board.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/coupons/coupon-number-board.js');
"use strict";


const {
  ReactButtonBet
} = svs.components;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;

const MatchRow = _ref => {
  let {
    eventItem,
    eventIndex,
    branding,
    productId,
    isMobile,
    isPixMix
  } = _ref;
  const {
    captionShort,
    captionLong,
    infoLine
  } = eventItem;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 notranslate",
    key: "".concat(captionShort, "-").concat(eventIndex)
  }, React.createElement("div", {
    className: "margin-top margin-bottom",
    "data-testid": "event-".concat(eventIndex, "-description")
  }, React.createElement("div", null, "".concat(eventIndex + 1, ". ").concat(isMobile ? captionShort : captionLong)), Boolean(infoLine) && React.createElement("div", {
    className: "padding-left-1 fc-grey-400"
  }, infoLine)), React.createElement("div", {
    className: "u-flex f-100 fc-white quickplay-modal2-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(EventOutcomes, {
    branding: branding,
    eventIndex: eventIndex,
    isPixMix: isPixMix,
    productId: productId
  })));
};

const EventOutcomes = _ref2 => {
  let {
    eventIndex,
    branding,
    productId,
    isPixMix
  } = _ref2;
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  }); 
  const pixData = pixHandler.getModel(productId);
  const signs = (pixData === null || pixData === void 0 ? void 0 : pixData.map(board => board[eventIndex])) || [];
  return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => {
    if (isSelected) {
      return React.createElement("div", {
        className: "quickplay-modal2-selection"
        ,
        key: "".concat(eventIndex, "_").concat(signIndex)
      }, React.createElement(ReactButtonBet, {
        "aria-hidden": "true",
        branding: branding,
        className: "margin-half",
        label: "X",
        selected: true,
        size: "200",
        tabIndex: "-1"
      }));
    }
    return React.createElement("div", {
      className: "quickplay-modal2-selection-empty"
      ,
      key: "".concat(eventIndex, "_").concat(signIndex)
    });
  }).filter(Boolean));
};

const CouponNumberBoard = _ref3 => {
  let {
    branding,
    drawData,
    isPixMix
  } = _ref3;
  const {
    productId,
    events
  } = drawData || {};
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("div", {
    className: "f-medium u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 fc-opacity-white-80"
  }, React.createElement("div", null, "Match"), React.createElement("div", {
    "data-testid": "table-of-events-goal-type"
  }, React.createElement("div", {
    className: "table-of-events-goal-type-rows"
  }, "M\xE5lrikaste Matcher"))), events.map((eventItem, eventIndex) => React.createElement(MatchRow, {
    branding: branding,
    eventIndex: eventIndex,
    eventItem: eventItem,
    isMobile: isMobile,
    isPixMix: isPixMix
    ,
    key: "".concat(eventItem.captionShort, "_").concat(eventIndex),
    productId: productId
  })));
};
setGlobal('svs.components.sport.quickplayModal2.coupons.CouponNumberBoard', CouponNumberBoard);

 })(window);